import { Component, NgZone } from '@angular/core';

import { NavController, ModalController, NavParams, IonicPage} from 'ionic-angular';

import { UserData } from '../../providers/user-data';
import { ToastController } from 'ionic-angular';

import moment from 'moment';
import { Http } from '@angular/http';

import { CommonData } from '../../providers/common-data';
import { UEModel } from '../ue/ue-model';
import { UEUploadPage } from '../ue/ue-upload';
import { PPListPage } from '../pp-list/pp-list';
import { AlertController } from 'ionic-angular';
import { UEData } from '../../providers/ue-data';
import { UEEditPage } from './ue-edit';

declare var CordovaExif : any;
declare var cordova : any;
declare var FileTransfer : any;
declare var HTMLImageElement : any;
declare var navigator : any;
declare var device : any;

@Component({
  selector: 'ue-detail',
  templateUrl: 'ue-detail.html'
})
export class UEDetailPage {
  sNormalColor = "primary";
  sCheckedColor = "secondary";

  oSelectedUE;

  constructor(
              private navParams: NavParams
            , public navCtrl: NavController
            , public userData: UserData
            , public toastCtrl: ToastController
            , public zone: NgZone
            , public common: CommonData
            , public http: Http
            , public modalCtrl: ModalController
            , public ueModel: UEModel 
            , public alertCtrl: AlertController
            , public ueData: UEData
            ) {
    //let selectedpp = navParams.get('pp');
    
    this.init();
    //this.ueModel.iGrundid = navParams.data.grundid;
    this.oSelectedUE = navParams.data;
    
    //console.log(this.oSelectedUE);

   }

   init(){
  

   }

   confirmStorno(ue){
     let title = "";
     let param: any;
      
      title = "Soll UE mit Ref.Nr.:'"+ue.busid+"' wirklich storniert werden?";
     
      let alert = this.alertCtrl.create();
      alert.setTitle(title);
      alert.setSubTitle('Grund:');
      alert.addInput({
          type: 'textarea',
          label: 'Grund',
          
      });

      alert.addButton({
        text: 'Ja, stornieren',
        handler: (data: any) => {
            if(data[0]){
              this.storno(ue, data[0]);
            }
            else{
              let alert2 = this.alertCtrl.create();
              alert2.setTitle("Grund angeben");
              alert2.setSubTitle('Bitte geben Sie einen Grund für die Stornierung an');
              alert2.addButton('Ok');
              alert2.present();
            }
            //this.testCheckboxOpen = false;
        }
      });
      alert.addButton('Abbrechen');

      alert.present();
      
   }

   edit(){
     this.navCtrl.push(UEEditPage, this.oSelectedUE);
   }

   storno(ue,reason){
       
        Promise.all([
            this.ueData.sotrno(ue, reason),            
          ]).then(data => {
            //console.log(data);
            //this.einsatzplan = this.einsatzplanData.data;      
            this.navCtrl.pop();
          });   
   }

  
}



// WEBPACK FOOTER //
// ./src/pages/ue-list/ue-detail.ts